"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerContactSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class PartnerContactSearchResponse extends common_1.PaginatedResponse {
}
exports.PartnerContactSearchResponse = PartnerContactSearchResponse;
//# sourceMappingURL=partner-contact-search.response.js.map